import {idlAPIClient} from "./axios";
import {AxiosResponse} from "axios";
import Utils from "../utils";
import ApiUtils from "./api-utils";
import LoginRegistrationService from "./login-registration";

const downloadCite = async (format: string, recordIds: string[], tokenRequest:number = 0):Promise<any> => {
  try {
    const token: string | null = ApiUtils.getToken();
    if (token) {
      const response: AxiosResponse<any, any> = await idlAPIClient.post<any>(
        "citations/export",
        {
          "format": format,
          "ids": recordIds
        },{
          headers: {"x-csrf-token": token},
          withCredentials: true,
          responseType:'arraybuffer'
        });
      return response;
    }
 } catch (e: any) {
    const error = JSON.parse(JSON.stringify(e))
    if (((error.status === 403) || (error.status === 401)) && (tokenRequest < 1)) {
      const token: string | null = await LoginRegistrationService.getToken();
      if (token) {
        return await DownloadService.downloadCite(format, recordIds, 1)
      }
    } else {
      throw error
    }
  }
}


const downloadFile = async (documentId: string, fileName: string, progressCallback: Function | null = null):Promise<any> => {
  const response:AxiosResponse<any, any> = await idlAPIClient.get<any>(
    "files/" + documentId + '/' + fileName,
    {
      withCredentials: false,
      responseType: 'blob',
      onDownloadProgress: progressEvent => {
        if (progressCallback) {
          progressCallback(fileName, progressEvent);
        }
      }
    });
  return response;
}

const downloadAllFiles = async (documentId: string, filename: string, progressCallback: Function | null = null, tokenRequest:number = 0):Promise<any> => {
  try {
    const token: string | null = ApiUtils.getToken();
    if (token) {
      const response: AxiosResponse<any, any> = await idlAPIClient.get<any>(
        "files/" + documentId,
        {
          headers: {"x-csrf-token": token},
          withCredentials: true,
          responseType: 'blob',
          onDownloadProgress: progressEvent => {
            if (progressCallback) {
              progressCallback(filename, progressEvent);
            }
          }
        });
      return response;
    }
  } catch (e: any) {
    const error = JSON.parse(JSON.stringify(e))
    if (((error.status === 403) || (error.status === 401)) && (tokenRequest < 1)) {
      const token: string | null = await LoginRegistrationService.getToken();
      if (token) {
        return await DownloadService.downloadAllFiles(documentId, filename, progressCallback, 1)
      }
    } else {
      throw error
    }
  }
}

const bulkDownload = async (documentIds: string[], tokenRequest: number = 0):Promise<any> => {
  try {
    const token: string | null = await ApiUtils.getToken();
    if (token) {
      const response: AxiosResponse<any, any> = await idlAPIClient.post<any>(
        "files/bulk",
        {
          uid: Utils.generateUUID(),
          ids: documentIds
        },
        {
          headers: {"x-csrf-token": token},
          withCredentials: true
        });
      return response.data;
    }
  } catch ( e: any ) {
    const error = JSON.parse(JSON.stringify(e))
    if (((error.status === 403) || (error.status === 401)) && (tokenRequest < 1)) {
      const token: string | null = await LoginRegistrationService.getToken();
      if (token) {
        return await DownloadService.bulkDownload(documentIds,1)
      }
    } else {
      throw error
    }
  }
}

const DownloadService = {
  downloadCite,
  downloadAllFiles,
  bulkDownload,
  downloadFile
}

export default DownloadService;
